import scopeUtils from "../../../utils/scope";
import MarkdownIt from 'markdown-it';
import MarkdownItEmoji from 'markdown-it-emoji';
import EmojiConvertor from '../services/emojiSupports/emoji-maker';
import blockImagePlugin from 'markdown-it-block-image';
import * as _ from 'lodash';

const marked = new MarkdownIt();
marked.use(MarkdownItEmoji);
marked.use(blockImagePlugin, {
    outputContainer: true,
    containerClassName: "image-container"
});

function unindent(text) {
    if (!text) {
        return text;
    }

    let lines = text
        .replace(/\t/g, '  ')
        .split(/\r?\n/);

    let min = null;
    let len = lines.length;
    let i;

    for (i = 0; i < len; i++) {
        let line = lines[i];
        let l = line.match(/^(\s*)/)[0].length;
        if (l === line.length) {
            continue;
        }
        min = (l < min || min === null) ? l : min;
    }

    if (min !== null && min > 0) {
        for (i = 0; i < len; i++) {
            lines[i] = lines[i].substr(min);
        }
    }
    return lines.join('\n');
}

markdownTranspileDirective.$inject = ['$', '$timeout'];
markdownTranspileDirective.directiveName = "markdownTranspile";
markdownTranspileDirective.emojiConvertor = new EmojiConvertor();
markdownTranspileDirective.emojiConvertor.use_sheet = true;

function getParents(elem, selector) {
    // Element.matches() polyfill
    if (!Element.prototype.matches) {
        Element.prototype.matches =
            Element.prototype.matchesSelector ||
            Element.prototype.mozMatchesSelector ||
            Element.prototype.msMatchesSelector ||
            Element.prototype.oMatchesSelector ||
            Element.prototype.webkitMatchesSelector ||
            function (s) {
                let matches = (this.document || this.ownerDocument).querySelectorAll(s),
                    i = matches.length;
                while (--i >= 0 && matches.item(i) !== this) {
                }
                return i > -1;
            };
    }

    // Setup parents array
    let parents = [];

    // Get matching parent elements
    for (; elem && elem !== document; elem = elem.parentNode) {

        // Add matching parents to array
        if (selector) {
            if (elem.matches(selector)) {
                parents.push(elem);
            }
        } else {
            parents.push(elem);
        }

    }

    return parents;
}

function isElement(obj) {
    return obj instanceof HTMLElement;
}


function showEmoji(node) {
    if (node.textContent.trim().length < 1)
        return true;

    let nodeParents = getParents(node);

    // check if inside contenteditable div
    for (let p = 0; p < nodeParents.length; p++) {
        if (isElement(nodeParents[p]) && nodeParents[p].getAttribute('contenteditable') == 'true') return true;
    }

    let textToCheck = node.textContent.replace(/&amp;/g, '&').replace(/&/g, '&amp;');
    let modifiedText = textToCheck;
    let emojiExist = false;

    if (modifiedText.length > 0) {
        modifiedText = markdownTranspileDirective.emojiConvertor.replace_unified(modifiedText);
        if (modifiedText !== textToCheck) emojiExist = true;
    }

    if (emojiExist === true) {

        let element = node.parentElement;

        for (let p = 1; p < nodeParents.length; p++) {
            if (element === undefined || !isElement(element)) element = nodeParents[p];
        }

        if (element) {
            let html = element.innerHTML;
            if (html.toLowerCase().indexOf('document.write') === -1) {
                html = html.replace(/”/g, '&rdquo;');
                let replace = html.replace(textToCheck.replace(/\xa0/g, '&nbsp;').replace(/”/g, '&rdquo;'), modifiedText);
                element.innerHTML = replace;
            }
        }
    }
}

export default function markdownTranspileDirective($, timeout) {
    return {
        restrict: 'AE',
        scope: {
            markdownTranspile: '='
        },
        link: function (scope, element, attrs) {
            // scope.$watch('marked', set);

            timeout(() => {
                if (scope.markdownTranspile) {
                    set(scope.markdownTranspile);
                } else {
                    set(element.text());
                }
            });

            function processImageTag(text, startingPos = 0) {
                const chatImageStartingIndex = text.indexOf('![chatImage](', startingPos);

                if (chatImageStartingIndex == -1)
                    return text;

                const chatImageStringEndindex = text.indexOf(')', chatImageStartingIndex);

                const chatImageStr = text.substring(chatImageStartingIndex, chatImageStringEndindex + 1);

                let proceededText = _.trim(chatImageStr.split(' ')[0], ')') + ')';

                text = text.replace(chatImageStr, proceededText);
                return processImageTag(text, chatImageStringEndindex);
            }

            function set(text) {
                text = unindent(text || '');

                // fix image messages
                text = processImageTag(text);

                let transpiledText = marked.render(text);

                transpiledText = transpiledText.replace(/&lt;/g, '<')
                    .replace(/&quot;/g, '"')
                    .replace(/&gt;/g, '>');

                let transpiledDOM = $(transpiledText);

                $('a', transpiledDOM).each(function () {
                    let target = $(this).attr('target');
                    if (!target || target != "_parent") {
                        $(this).attr('target', '_blank');
                    }
                });

                scopeUtils.apply(scope, () => {
                    $(element).append(transpiledDOM);
                    showEmoji($(element)[0]);
                });
            }
        }
    };
}


// WEBPACK FOOTER //
// ./src/modules/shared/directives/markdownTranspileDirective.js